import React from "react";
import PaginatedTable from "../../../sharedComponents/tableWithPagination";

export default function MyFoodTable({ myFoodList, getData, history, deleteItem}) {

    const renderEditFoodItem = (foodId) => {
		history.push(`/nutrition/myfood/${foodId}/edit`);
    };
    
    const columns = [
        {
			Header: "Name",
			accessor: "name",
			width: 250
		},
		{
			Header: "Description",
			accessor: "long_desc",
			width: 800
		},
        {
			Header: "Actions",
			accessor: "id",
			sortable: false,
			className: "text-right",
			headerClassName: "text-right",
			width: 150,
			Cell: ({ original }) => (
				<div>
					<button
						className="btn btn-success btn-ghost btn-cell btn-sm mr-2"
						onClick={() => renderEditFoodItem(original.id)}>
						<i className="icon icon-edit" />
					</button>
					<button className="btn btn-danger btn-ghost btn-cell btn-sm" onClick={() => deleteItem(original.id)}>
						<i className="icon icon-trash" />
					</button>
				</div>
			)
		}
    ];

    return (
		<div className="card card-primary w-100 h-100 m-0 p-4 border-0 table-container">
			<div className="pt-3 last-child-b-0">
                {myFoodList && myFoodList.results.length ? (
                    <PaginatedTable
                        data={myFoodList && myFoodList.results}
                        columns={columns}
                        totalItems={myFoodList && myFoodList.count}
                        prev={myFoodList && myFoodList.previous}
                        next={myFoodList && myFoodList.next}
                        pageSize={20}
                        onPagination={(e) => {
                            getData(`limit=20&${e}`);
                        }}
                    />
                ) : null}
			</div>
		</div>
	);
}